/** @jsxImportSource @emotion/react */
import { FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';
import { Global, ThemeProvider } from '@zip/business-components';
import {
  AnalyticsProvider,
  Auth0Provider,
  CookiesProvider,
  FeatureFlagsProvider,
  MerchantDataProvider,
  NavigationProvider,
  PageTracking,
  SnackbarProvider,
} from 'contexts';
import { theme } from 'global';
import Layout from 'global/layout';
import { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';

const App: FC = () => (
  <AnalyticsProvider>
    <PageTracking>
      <FpjsProvider
        loadOptions={{
          apiKey: process.env.REACT_APP_FPJS_PUBLIC_KEY,
          endpoint: process.env.REACT_APP_FPJS_ENDPOINT,
        }}
      >
        <Auth0Provider
          domain={process.env.REACT_APP_AUTH0_DOMAIN}
          clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
          redirectUri={`${window.location.origin}/callback`}
        >
          <CookiesProvider>
            <ThemeProvider theme={theme}>
              <Global />
              <SnackbarProvider>
                <MerchantDataProvider>
                  <FeatureFlagsProvider>
                    <BrowserRouter>
                      <NavigationProvider>
                        <Layout />
                      </NavigationProvider>
                    </BrowserRouter>
                  </FeatureFlagsProvider>
                </MerchantDataProvider>
              </SnackbarProvider>
            </ThemeProvider>
          </CookiesProvider>
        </Auth0Provider>
      </FpjsProvider>
    </PageTracking>
  </AnalyticsProvider>
);

export default App;
